import React from 'react';
import L from 'leaflet';
import { Marker } from 'react-leaflet';
import ReactDOMServer from 'react-dom/server';
import './MetroInfoTagStyles.scss';
import CloudArrowIcon from '../icons/CloudArrow';
import MetroIcon from '../icons/Metro';
import TemperatureIcon from '../icons/Temperature';
import CabinetIcon from '../icons/Cabinet';
import LightningIcon from '../icons/Lightning';
import cn from 'classnames';
import EmsIcon from '../icons/Ems';

const MetroInfoTag = ({ onRamp, onRampConfiguration, position, capacityConfiguration, capacity, iconSize, showEms }) => {
  const offset = iconSize < 0.5 ? 7 : 13;
  const coordinates = { lat: position[0], lng: position[1] };
  const hideText = iconSize > 0.9;
  const html = ReactDOMServer.renderToString(
    <div className={cn('metro-tag', { smallIcon: iconSize < 0.7 })}>
      {(onRampConfiguration.showCount || onRampConfiguration.showMarketShare) && onRamp && (
        <div className="row">
          <CloudArrowIcon />
          {onRampConfiguration.showCount && <span>{onRamp[0]}</span>}
          {onRampConfiguration.showCount && onRampConfiguration.showMarketShare && '•'}
          {onRampConfiguration.showMarketShare && (
            <span>
              {onRamp[1]}% {hideText && ' of On-ramps'}
            </span>
          )}
        </div>
      )}
      {capacity && (
        <>
          {capacityConfiguration.datacenters && (
            <div className="row">
              <MetroIcon viewBox="0 0 16 16" />
              <span>
                {capacity.datacenters} {hideText && 'Data Centers'}
              </span>
            </div>
          )}
          {capacityConfiguration.cabe && (
            <div className="row">
              <CabinetIcon />
              <span>
                {capacityConfiguration.cabe === 'total' ? capacity.cabETotal : capacity.cabEAvailable} {hideText && 'CabE'}
              </span>
            </div>
          )}
          {capacityConfiguration.kva && (
            <div className="row">
              <LightningIcon />
              <span>
                {capacityConfiguration.kva === 'metro'
                  ? capacityConfiguration.metro === 'total'
                    ? capacity.capacityTotal
                    : capacity.capacityAvailable
                  : capacityConfiguration === 'average'
                  ? capacity.capacityAverage
                  : capacity.capacityAvailableMax}
                {hideText && 'kVA'}
              </span>
            </div>
          )}
          {capacityConfiguration.cooling && capacity.isCoolingAvailable && (
            <div className="row">
              <TemperatureIcon viewBox="0 0 6 10" /> <span>H-DC</span>
            </div>
          )}
        </>
      )}
      {showEms && (
        <div className="row">
          <EmsIcon /> <span>EMS</span>
        </div>
      )}
    </div>
  );

  const icon = L.divIcon({
    html,
    //iconAnchor: [0, 0], // Adjust dynamically
    className: 'metroTag',
    iconAnchor: L.point(0, offset),
  });

  return (
    <Marker
      position={coordinates}
      icon={icon}
      zIndexOffset={0}
      //eventHandlers={{
      //    add: (e) => {
      //       const div = e.target._icon;
      //       if (div) {
      //          const height = div.clientHeight;
      //          const width = div.clientWidth;
      //       e.target.setIcon(L.divIcon({
      //              html: html,
      //          className: 'metroTag',
      //              iconAnchor: [width / 2, height / 2], // Adjust based on actual size
      //          }));
      //      }
      // }
      // }}
    />
  );
};

export default MetroInfoTag;
